module.exports = __webpack_public_path__ + "img/Bougeoirs_et_photophores.c373288.jpg";